<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="adaptationModal"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      :visible.sync="dialogVisible"
      width="1100px"
      @close="$reset('form')"
    >
      <el-form
        v-loading="contentLoading"
        :disabled="disabled"
        ref="form"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px"
      >
        <div class="editTitle">基本信息</div>
        <el-row>
          <el-col v-if="model.pkId" :span="12">
            <el-form-item label="工单编号" prop="productionOrderNo">
              <el-input v-model="model.productionOrderNo" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工单类型" prop="productionOrderType">
              <el-select v-model="model.productionOrderType" disabled>
                <el-option label="销售订单" :value="1" />
                <el-option label="自制工单" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称" prop="materialName">
              <el-input v-model="model.materialName" placeholder="请选择物料" readonly>
                <el-button slot="append" @click="$refs.selectMaterial.open(10)" icon="el-icon-search"></el-button>
              </el-input>
              <material-select ref="selectMaterial" @select="selectMaterial" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品工艺" prop="routingName">
              <el-input :disabled="!model.materialName" v-model="model.routingName" placeholder="请选择产品工艺" readonly>
                <el-button slot="append" @click="$refs.selectRtRouteMaterial.open(model.materialNo)" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产数量" prop="quantity">
              <el-input
                :disabled="!model.materialName || model.routingName === '分条'"
                v-model="model.quantity"
                @input="quantityInput"
                placeholder="请输入生产数量"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开工时间" prop="planStartTime">
              <el-date-picker
                v-model="model.planStartTime"
                style="width: 100%"
                type="datetime"
                placeholder="选择开工时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完工时间" prop="planFinishTime">
              <el-date-picker
                v-model="model.planFinishTime"
                style="width: 100%"
                type="datetime"
                placeholder="选择完工时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!model.pkid">
            <el-form-item label="直接派工" prop="isDispatch">
              <el-select v-model="model.isDispatch" placeholder="请选择是否直接派工">
                <el-option label="否" :value="false" />
                <el-option label="是" :value="true" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!model.pkid">
            <el-form-item v-if="model.isDispatch" label="生产中心" prop="workCenterId">
              <el-select v-model="model.workCenterId" placeholder="请选择生产中心" readonly>
                <el-option v-for="item in workCenters" :key="item.pkid" :label="item.workCenterName" :value="item.workCenterId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="editTitle">生产BOM{{ "（共计 " + model.bomList.length + " 条）" }}</div>
        <Table border :columns="columns" :data="model.bomList"> </Table>
        <div class="editTitle" style="margin-top: 15px">产品工艺信息</div>
        <el-button type="primary" :disabled="!model.routingName || disabled" style="margin-bottom: 8px" @click="partsModal">
          添加
        </el-button>
        <div style="display: flex">
          <div class="tree">
            <el-tree
              ref="tree"
              :data="treeData"
              node-key="key"
              :props="treeProps"
              highlight-current
              default-expand-all
              :expand-on-click-node="false"
              @current-change="currentChange"
            />
          </div>
          <div class="treeContent">
            <Table :draggable="!disabled" @on-drag-drop="tableDrag" border stripe :columns="routeColumns" :data="tableData">
              <template slot="action" slot-scope="{ row, index }">
                <el-button type="danger" :disabled="row.isMainSn || disabled" @click="deleteHandle(row, index)">删除</el-button>
              </template>
            </Table>
          </div>
        </div>
      </el-form>
      <MaterialSelect ref="selectMaterial" @select="selectMaterial"></MaterialSelect>
      <rt-route-material-select ref="selectRtRouteMaterial" @select="selectRtRouteMaterial" />
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="!disabled" type="primary" @click="handleOk" :loading="submitLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-el-drag-dialog :visible.sync="childDialog" :close-on-click-modal="false" title="添加部件" width="600px">
      <el-form ref="formChild" :model="modelChild" :rules="childOneRuleValidate" class="form" label-width="90px">
        <el-form-item label="部件名称" prop="partsName">
          <el-input v-model="modelChild.partsName" placeholder="请选择部件" readonly>
            <el-button slot="append" @click="$refs.selectParts.open()" icon="el-icon-search"></el-button>
          </el-input>
          <material-select ref="selectParts" @select="selectParts" />
        </el-form-item>
        <el-form-item label="固定工时" prop="fixedWorkingTime">
          <el-input v-model="modelChild.fixedWorkingTime" placeholder="请输入固定工时" />
        </el-form-item>
        <el-form-item label="变动工时" prop="variableWorkingTime">
          <el-input v-model="modelChild.variableWorkingTime" placeholder="请输入变动工时" />
        </el-form-item>
        <el-form-item label="是否唯一码" prop="isUniqueSn">
          <el-select v-model="modelChild.isUniqueSn" clearable placeholder="请选择是否唯一码">
            <el-option label="唯一码" :value="true" />
            <el-option label="自制条码" :value="false" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="childDialogOne = false">取消</el-button>
        <el-button type="primary" @click="addParts">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MaterialSelect from "@/views/information/Material/MaterialSelect";
import RtRouteMaterialSelect from "@/views/information/RtRouteMaterial/RtRouteMaterialSelect";
export default {
  components: {
    MaterialSelect,
    RtRouteMaterialSelect,
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      submitLoading: false,
      childDialog: false,
      contentLoading: false,
      workCenters: [],
      model: {
        productionOrderNo: "",
        productionOrderType: 2,
        materialNo: "",
        materialId: "",
        materialName: "",
        routeId: "",
        routingName: "",
        quantity: "",
        planStartTime: "",
        planFinishTime: "",
        isDispatch: false,
        bomList: [],
        routeList: [],
        workCenterId: "",
      },
      bomListCopy: [],
      treeData: [],
      treeProps: {
        label: "title",
      },
      tableData: [],
      currentTree: {},
      ruleValidate: {
        materialName: [{ required: true, message: "请选择物料", trigger: "change" }],
        routingName: [{ required: true, message: "请选择产品工艺", trigger: "change" }],
        quantity: [{ required: true, message: "请输入生产数量", trigger: "blur" }],
        planStartTime: [{ required: true, message: "请选择开工时间", trigger: "change" }],
        planFinishTime: [{ required: true, message: "请选择完工时间", trigger: "change" }],
        isDispatch: [{ required: true, message: "请选择是否直接派工", trigger: "change" }],
        workCenterId: [{ required: true, message: "请选择生产中心", trigger: "change" }],
      },
      childOneRuleValidate: {
        partsName: { required: true, message: "请选择物料", trigger: "change" },
        fixedWorkingTime: { required: true, message: "请输入固定工时", trigger: "blur" },
        variableWorkingTime: { required: true, message: "请输入变动工时", trigger: "blur" },
        isUniqueSn: { required: true, message: "请选择是否唯一码", trigger: "change" },
      },
      columns: [
        {
          title: "物料编号",
          key: "materialNo",
          width: 120,
          align: "center",
        },
        {
          title: "物料名称",
          key: "materialName",
        },
        {
          title: "数量",
          key: "quantity",
          width: 80,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          width: 80,
          align: "center",
        },
      ],
      routeColumns: [
        {
          type: "index",
          width: 50,
          align: "center",
        },
        {
          title: "部件编号",
          key: "partsNo",
          width: 120,
          align: "center",
        },
        {
          title: "部件名称",
          key: "partsName",
          minWidth: 360,
          tooltip: true,
        },
        {
          title: "主条码",
          key: "isMainSn",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isMainSn ? "是" : "否");
          },
        },
        {
          title: "唯一码",
          key: "isUniqueSn",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isUniqueSn ? "是" : "否");
          },
        },
        {
          title: "固定工时",
          key: "fixedWorkingTime",
          width: 90,
          align: "center",
        },
        {
          title: "变动工时",
          key: "variableWorkingTime",
          width: 90,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 80,
          slot: "action",
          fixed: "right",
        },
      ],
      modelChild: {
        partsName: "",
        partsNo: "",
        fixedWorkingTime: "",
        variableWorkingTime: "",
        isUniqueSn: "",
      },
    };
  },

  methods: {
    open(row, mark) {
      this.dialogVisible = true;
      this.disabled = mark;
      if (row) {
        this.getData(row.pkid);
      }
    },

    selectMaterial(row) {
      this.resetFiled(["routingName", "quantity", "isDispatch"]);
      this.treeData = [];
      this.tableData = [];
      this.model.materialNo = row.materialNO;
      this.model.materialId = row.materialID;
      this.model.materialName = row.materialName;
      this.getBomList();
    },

    // 根据物料ID查询BOM信息
    getBomList() {
      this.$http.get("basic", `productionOrders/bomlist?materialId=${this.model.materialId}`).then((resp) => {
        if (resp.success) {
          if (!resp.data) {
            this.model.bomList = [];
            this.$confirm("该物料暂无BOM信息，请先添加！", "提示", {
              type: "warning",
              showCancelButton: false,
            });
          } else {
            this.model.bomList = resp.data;
            this.bomListCopy = JSON.stringify(this.model.bomList);
            if (this.model.quantity) {
              this.quantityInput();
            }
          }
        }
      });
    },

    selectRtRouteMaterial(row) {
      this.resetFiled(["isDispatch"]);
      this.model.routeId = row.pkid;
      this.model.routingName = row.routingName;
      if (this.model.routingName === "分条") {
        this.model.quantity = 1;
      }
      this.getWorkCenterInfo(row.routingId);
      this.getWorkInfoByRouteId(this.model.routeId);
    },

    // 根据工艺路线查询生产中心
    getWorkCenterInfo(routeId) {
      this.$http.get("basic", `rtRoutes/workcenters/${routeId}`).then((resp) => {
        if (resp.success) {
          this.workCenters = resp.data;
        }
      });
    },

    quantityInput() {
      if (this.model.bomList.length) {
        const arr = JSON.parse(this.bomListCopy);
        arr.forEach((item) => {
          item.quantity *= this.model.quantity;
        });
        this.model.bomList = arr;
      }
    },

    resetFiled(data) {
      data.forEach((item) => {
        let result = this.$refs.form.fields.find((f) => f.prop == item);
        if (result) {
          result.resetField();
        }
      });
    },

    getData(pkid) {
      this.contentLoading = true;
      this.$http
        .get("basic", `productionOrders/${pkid}`)
        .then((resp) => {
          if (resp.success) {
            this.model = Object.assign(this.model, resp.data);
            let temp = JSON.parse(JSON.stringify(resp.data.bomList));
            temp.forEach((item) => {
              item.quantity = item.quantity / this.model.quantity;
            });
            this.bomListCopy = JSON.stringify(temp);
            this.treeData = resp.data.treeData;
            this.model.routeList = resp.data.routeList;
            if (this.treeData.length) {
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.treeData[0].key);
                this.currentTree = this.treeData[0];
                this.tableData = this.model.routeList.filter((item) => item.processIndex === 1);
              });
            }
          }
          this.contentLoading = false;
        })
        .catch(() => {
          this.contentLoading = false;
        });
    },

    partsModal() {
      this.childDialog = true;
      this.$nextTick(() => {
        this.$refs.formChild.resetFields();
      });
    },

    handleOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.$moment(this.model.planStartTime).valueOf() >= this.$moment(this.model.planFinishTime).valueOf()) {
            this.$confirm("请选择有效的时间范围", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          if (!this.model.bomList) {
            this.$confirm("生产BOM不能为空", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          // const newArr = this.getGroupByProcessIndex(this.originTableData);
          // newArr.forEach((item) => {
          //   item.data.forEach((i, index) => {
          //     i.scanIndex = index + 1;
          //   });
          // });
          // let finalArr = [];
          // newArr.forEach((item) => {
          //   item.data.forEach((i) => {
          //     finalArr.push(i);
          //   });
          // });
          // this.model.routeList = finalArr;
          this.submitLoading = true;
          this.$http
            .save("basic", "productionOrders", this.model)
            .then((resp) => {
              if (resp.success) {
                this.visible = false;
                if (this.model.pkid) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
              this.submitLoading = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },

    // ---------------------------------------------------------------产品工艺信息api-------------------------------------------

    // 根据工艺路线id查询产品工艺信息
    getWorkInfoByRouteId(routeId) {
      this.$http.get("basic", `rtRouteMaterials/queryProcessTreeByMainId?id=${routeId}`).then((resp) => {
        if (resp.success) {
          this.treeData = resp.data.treeData;
          this.model.routeList = resp.data.details;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].key);
            this.tableData = this.model.routeList.filter((item) => item.processIndex === 1);
            this.currentTree = this.treeData[0];
          });
        }
      });
    },

    // 切换选中菜单
    currentChange(node) {
      if (node.hasOwnProperty("children")) {
        this.currentTree = node;
        this.tableData = this.model.routeList.filter((item) => item.processIndex === node.processIndex);
      }
    },

    // 删除部件
    deleteHandle(row, index) {
      this.tableData.splice(index, 1);
      let newArr = [];
      this.model.routeList.forEach((item) => {
        if (item.scanIndex !== row.scanIndex || item.processIndex !== row.processIndex) {
          newArr.push(item);
        }
      });
      this.model.routeList = newArr;
    },

    // 选择部件
    selectParts(row) {
      this.modelChild.partsName = row.materialName;
      this.modelChild.partsNo = row.materialNO;
    },

    // 添加部件
    addParts() {
      this.$refs.formChild.validate((valid) => {
        if (valid) {
          var newArr = this.tableData.slice().sort(function (a, b) {
            return b.scanIndex - a.scanIndex;
          });
          const obj = {
            scanIndex: newArr[0].scanIndex + 1,
            isMainSn: false,
            processNo: this.currentTree.processNo,
            processId: this.currentTree.processId,
            processName: this.currentTree.title,
            processIndex: this.currentTree.processIndex,
            ...this.modelChild,
          };
          this.tableData.push(obj);
          this.model.routeList.push(obj);
          this.childDialog = false;
        }
      });
    },

    //  表格拖动
    tableDrag(index1, index2) {
      if (index1 != 0 && index2 != 0) {
        const temp = this.tableData[index1].scanIndex;
        this.tableData[index1].scanIndex = this.tableData[index2].scanIndex;
        this.tableData[index2].scanIndex = temp;
        this.tableData[index1] = this.tableData.splice(index2, 1, this.tableData[index1])[0];
        const newArr = this.model.routeList.filter((item) => item.processIndex !== this.currentTree.processIndex);
        this.model.routeList = newArr.concat(this.tableData);
      } else {
        this.$message.warning("禁止改变主条码顺序");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tree {
  flex: 1;
  border: 1px solid #ddd;
  margin-right: 5px;
  padding: 5px;
}
.treeContent {
  width: 870px;
}
</style>
